export interface IUser {
  id?: number;
  name: string;
  avatar: string;
  lastLogin: string;
}
